// localStorage "raise hand" and "reaction" pubnub message timeToken key

export enum LS_KEYS {
  LS_RAISE_HAND_MSG_TT = 'raiseHandMsgTT',
  LS_REACTION_MSG_TT = 'reactionMsgTT',
  LS_REACTION_MSG_VALUE = 'reactionMsgVal',
}

export const PUBNUB_SUBSCRIBE_KEY =
  process.env.MODE === 'local' || process.env.MODE === 'dev'
    ? 'sub-c-003d6883-efed-45ba-968c-33dcbe0bfe00'
    : 'sub-c-003d6883-efed-45ba-968c-33dcbe0bfe00';

export const PUBNUB_PUBLISH_KEY =
  process.env.MODE === 'local' || process.env.MODE === 'dev'
    ? 'pub-c-cfb1125b-e5ed-4458-af75-7322cc871541'
    : 'pub-c-cfb1125b-e5ed-4458-af75-7322cc871541';

export enum PB_CHANNELS {
  REACTIONS = 'reactions',
  BLOCKED = 'blocked',
  USERS = 'users',
  ALREADY_SPOKE = 'alreadySpoke',
  SYSTEM = 'system',
  OCCUPANCY = 'occupancy',
}
export enum PB_OCCUPANCY_CHANNELS {
  AUTH = 'auth',
  LISTENERS = 'listeners',
}
